var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_10305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3543 12.7734C23.5793 13.3684 24.7343 14.1151 25.8077 15.0017L24.5593 16.2501C23.8827 15.7017 23.1477 15.2117 22.366 14.7684V12.7734H22.3543ZM6.96602 12.7734V14.7567C6.20768 15.1884 5.47268 15.6784 4.78435 16.2384L3.53602 14.9901C4.59768 14.1151 5.75268 13.3801 6.96602 12.7734ZM14.666 8.66675C9.36935 8.66675 4.56268 10.7434 1.00435 14.1151C0.794349 14.3251 0.666016 14.6167 0.666016 14.9434C0.666016 15.2701 0.794349 15.5617 1.00435 15.7601L3.89768 18.6534C4.10768 18.8634 4.39935 18.9917 4.72602 18.9917C5.04102 18.9917 5.33268 18.8751 5.54268 18.6651C6.46435 17.8134 7.50268 17.0784 8.64602 16.5067C9.03102 16.3201 9.29935 15.9117 9.29935 15.4567V11.8401C10.991 11.2917 12.7993 11.0001 14.666 11.0001C16.5327 11.0001 18.341 11.2917 20.021 11.8517V15.4684C20.021 15.9351 20.2893 16.3317 20.6743 16.5184C21.8177 17.0901 22.8677 17.8134 23.7893 18.6767C23.9993 18.8751 24.291 19.0034 24.606 19.0034C24.9327 19.0034 25.2243 18.8751 25.4343 18.6651L28.3277 15.7717C28.5377 15.5617 28.666 15.2701 28.666 14.9434C28.666 14.6167 28.5377 14.3251 28.3277 14.1151C24.7693 10.7434 19.9627 8.66675 14.666 8.66675Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_10305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.666016 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.cd9a482d68dd66e3ab306d00509816fb.svg";
export { ForwardRef as ReactComponent };